import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { showLoginToast } from './toastUtils';
import '../css/Login.css';

const GuestProtectedRoute = ({ children }) => {
    const { user, isInitializing, canAccess } = useContext(AuthContext);
    const location = useLocation();

    useEffect(() => {
        if (!isInitializing && (!user || !canAccess(location.pathname))) {
            showLoginToast('Please log in to access this page');
        }
    }, [user, isInitializing, location.pathname, canAccess]);

    if (isInitializing) {
        return null; // Or a loading spinner
    }

    // If user doesn't have access, don't render the protected content
    if (!user || !canAccess(location.pathname)) {
        return null;
    }

    return children;
};

export default GuestProtectedRoute; 